<script>
    import { page } from '$app/stores';
    import { site_origin } from './stores/globals';

    const same_as = ($page.data.social_links || [])
        .filter((l) => l.org_sameas !== false)
        .map((l) => l.url);

    const organization = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Critikid',
        url: site_origin,
        logo: {
            '@type': 'ImageObject',
            url: `${site_origin}/android-chrome-512x512.png`,
            width: 512,
            height: 512
        },
        founder: {
            '@type': 'Person',
            name: 'Stephanie Simoes'
        },
        sameAs: same_as
    };

    const website = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Critikid',
        url: site_origin
    };
</script>

<svelte:head>
    {@html `<script type="application/ld+json">${JSON.stringify(organization)}</script>`}
    {@html `<script type="application/ld+json">${JSON.stringify(website)}</script>`}
</svelte:head>
